import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ListOfLists } from './components/ListOfLists';
import { ListView } from './components/ListView';
import { ListEditor } from './components/ListEditor';
import { HistoryView } from './components/HistoryView';
import { CandidateReview } from './components/CandidateReview';
import { Login } from './authComponents/Login';
import { Signup } from './authComponents/Signup';
import { PasswordReset } from './authComponents/PasswordReset';
import { Header } from './components/Header';
import './App.css';

function isLoggedIn(): boolean {
  return !!localStorage.getItem('access_token');
}

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/password-reset" element={<PasswordReset />} />
            <Route path="/reset-password" element={<PasswordReset />} />
            <Route path="/" element={<ProtectedRoute><ListOfLists /></ProtectedRoute>} />
            <Route path="/lists/new" element={<ProtectedRoute><ListEditor /></ProtectedRoute>} />
            <Route path="/lists/:id" element={<ProtectedRoute><ListView /></ProtectedRoute>} />
            <Route path="/lists/:id/edit" element={<ProtectedRoute><ListEditor /></ProtectedRoute>} />
            <Route path="/lists/:id/history" element={<ProtectedRoute><HistoryView /></ProtectedRoute>} />
            <Route path="/candidates" element={<ProtectedRoute><CandidateReview /></ProtectedRoute>} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
};

export default App;
